module.exports = __webpack_public_path__ + "img/spyder.4e6c24be.png";